module.exports = __webpack_public_path__ + "img/setinha-left-preto.3dd06f88.svg";